var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-container"},[_c('el-button',{attrs:{"size":"medium"},on:{"click":_vm.handlePre}},[_vm._v("上一页")]),_c('el-button',{attrs:{"size":"medium"},on:{"click":_vm.handleNext}},[_vm._v("下一页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }